module.exports = __webpack_public_path__ + "static/media/400384_01.6c5a506f.png";